import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { db } from "./firebase";
import Leopardy from "./Leopardy";

export default function LeopardyGameShell({ role = "viewer" }) {
  const { gameId } = useParams();
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!gameId) return;
    const unsub = onSnapshot(
      doc(db, "games_leopardy", gameId),
      (snap) => {
        if (!snap.exists()) {
          setError("Game not found.");
          setGame(null);
        } else {
          setGame({ id: snap.id, ...snap.data() });
          setError(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("[LeopardyGameShell] load", err);
        setError(err.message || "Failed to load game.");
        setLoading(false);
      }
    );
    return () => unsub();
  }, [gameId]);

  if (loading) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", minHeight: "60vh", gap: 2 }}>
        <CircularProgress />
        <div>Loading game…</div>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", minHeight: "60vh" }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!game?.data) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", minHeight: "60vh" }}>
        <Alert severity="warning">Game has no data yet.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ position: "absolute", top: 12, right: 12, zIndex: 10, px: 1.5, py: 0.5, borderRadius: 999, background: "rgba(0,0,0,0.5)", color: "#fff", fontSize: 12 }}>
        {role === "host" ? "Host/Judge View" : role === "player" ? "Player View" : "Class View"}
      </Box>
      <Leopardy data={game.data} gameId={game.id} gameState={game.state} role={role} />
      <Box sx={{ maxWidth: 1100, mx: "auto", px: 2, py: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Loaded from saved Leopardy game {game.id}. Title: {game.title || game.data?.title || "Untitled"}.
        </Typography>
      </Box>
    </Box>
  );
}
